import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Icon } from 'semantic-ui-react'

class ActionsDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            icon: "triangle right"
        }

        this.toggleHover = this.toggleHover.bind(this);
    }

    toggleHover(e){
        if (this.state.icon === "triangle right"){
            this.setState({
                icon: "triangle down"
            })
        }
        else{
            this.setState({
                icon: "triangle right"
            })
        }
    }

    render() {
        return (
            <div className="customDropdown">
                <div className="dropbtn" onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover} style={{backgroundColor: "#2b276e", color: "white", borderRadius: "0px", textAlign: 'center'}}>
                    <span><Icon name="cog" /> <b>Settings</b></span>
                </div>
                <div className="dropdown-content">
                    {this.props.actionButtons}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(ActionsDropdown)